{
 "source": "HVSC /MUSICIANS/C/Clarke_Peter/Bubble_Bobble.sid (md5 049595d6dc96a7d3d00896e169f68b1f): the game's sound driver and its effect blocks, run on src/audio/sid/cpu6502.ts",
 "note": "Generated by tools/capture-sfx.mjs - do not edit. Per effect: base64 of packed frames (per 50 Hz frame a write count, then register/value pairs to voice 1, $D400-$D406, in the order the driver made them; frame 0 is sfx_start's, the last silences the voice).",
 "frameHz": 50,
 "captured": "subtune 2 playing, 50 frames in; the same under subtunes 1 (after its intro), 2, 3 and 6 at any time",
 "effects": [
  {
   "name": "jump",
   "index": 0,
   "request": "$B1",
   "block": "$F976",
   "bytes": "bc 02 70 fe 00 00 00 00 02 02 00 00 00 05 00 00 00 04 00 00 00 00 00 04 49 07 fa 23 23 2b",
   "frames": 37,
   "introStartsDiffering": "12/236",
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+gUHBEkDBAIAABYBDQUEQAIAAwQA0gEPBAIAAwQAjgESBAIAAwQA/gEQBAIAAwQAbgEPBAIAAwQAKgESBAIAAwQA5gEUBAIAAwQAVgETBAIAAwQAxgERBAIAAwQAggEUBAIAAwQAPgEXBAIAAwQArgEVBAIAAwQAHgEUBAIAAwQA2gEWBAIAAwQAlgEZBAIAAwQABgEYBAIAAwQAdgEWBAIAAwQAMgEZBAIAAwQA7gEbBAIAAwQAXgEaBAIAAwQAzgEYBAIAAwQAigEbBAIAAwQARgEeBAIAAwQAtgEcBAIAAwQAJgEbBAIAAwQA4gEdBAIAAwQAngEgBAIAAwQADgEfBAIAAwQAfgEdBAIAAwQAOgEgBAIAAwQA9gEiBAIAAwQAZgEhBAIAAwQA1gEfBAIAAwQAkgEiBAIAAwQATgElBAIAAwQAvgEjBwYABQAEAAMAAgABAAAA"
  },
  {
   "name": "pickup",
   "index": 1,
   "request": "$B0 = 1",
   "block": "$F994",
   "bytes": "d5 fb 01 00 a0 0f 00 00 06 03 03 00 02 04 02 02 00 05 40 00 c0 ff 00 08 49 07 f9 17 28 4a",
   "frames": 42,
   "introStartsDiffering": "54/236",
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+QUHBEkDCAIAAGwBTgMEQAJAAwQCAoADBAQCQAMEAEEBSgQCAAMEABYBRgQCQAMEAOsBQQQCgAMEAMABPQQCQAMEAJUBOQQCAAMEAGoBNQQCQAMEAGsBNQQCgAMEAGwBNQQCQAMEAG0BNQQCAAMEAA0BRQQCQAMEAK0BVAQCgAMEAE0BZAQCQAMEAE0BZAQCAAMEAE0BZAQCQAMEAE0BZAQCgAMEAE0BZAQCQAMEAE0BZAQCAAMEAE0BZAQCQAMEAE0BZAQCgAMEAE0BZAQCQAMEAE0BZAQCAAMEAE0BZAQCQAMEAE0BZAQCgAMEAE0BZAQCQAMEAE0BZAQCAAMEAE0BZAQCQAMEAE0BZAQCgAMEAE0BZAQCQAMEAE0BZAQCAAMEAE0BZAQCQAMEAE0BZAQCgAMEAE0BZAQCQAMEAE0BZAQCAAMEAE0BZAQCQAMEAE0BZAQCgAMEAE0BZAQCQAMEAE0BZAQCAAMEAE0BZAcGAAUABAADAAIAAQAAAA=="
  },
  {
   "name": "boltHit",
   "index": 2,
   "request": "$B0 = 2",
   "block": "$F9B2",
   "bytes": "30 f8 38 ff 06 ff 00 00 01 02 01 00 04 04 00 00 00 00 00 00 00 00 00 00 89 07 fa 2d 1e 2e",
   "frames": 32,
   "introStartsDiffering": "0/236",
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+gUHBIkDAAIAAI8BDwEEgAAAAAIAvwEHAgD3AQYCAC8BBgIANQEFAgA1AQUCADUBBQIANQEFAgA1AQUCADUBBQIANQEFAgA1AQUCADUBBQIANQEFAgA1AQUCADUBBQIANQEFAgA1AQUCADUBBQIANQEFAgA1AQUCADUBBQIANQEFAgA1AQUCADUBBQIANQEFAgA1AQUHBgAFAAQAAwACAAEAAAA="
  },
  {
   "name": "extraLife",
   "index": 3,
   "request": "$B0 = 3",
   "block": "$F9D0",
   "bytes": "00 00 00 00 01 00 05 00 ed f9 00 07 00 0d 00 00 00 00 00 00 00 00 00 08 49 07 fb 23 29 3c",
   "frames": 43,
   "introStartsDiffering": "12/236",
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+wUHBEkDCAIAAO0BIgMEQADtASIAAAAAAgChAS4AAAAAAgA1AScAAAAAAgBXATQAAAAAAgABASwAAAAAAgABASwAAAAAAgABASwAAAAAAgABASwAAAAAAgDtASIHBgAFAAQAAwACAAEAAAA="
  },
  {
   "name": "potion",
   "index": 4,
   "request": "$B0 = 4",
   "block": "$F9F5",
   "bytes": "90 01 00 00 00 00 00 00 1e 00 00 00 00 05 04 04 00 05 f0 01 10 fe 00 08 49 07 fb 32 32 14",
   "frames": 52,
   "introStartsDiffering": "0/236",
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+wUHBEkDCAIAAHgBAwUEQALwAwUACAEFBALgAwcAmAEGBALQAwkAKAEIBALAAwsAuAEJBALQAwkASAELBALgAwcA2AEMBALwAwUAaAEOBAIAAwQA+AEPBALwAwUAiAERBALgAwcAGAETBALQAwkAqAEUBALAAwsAOAEWBALQAwkAyAEXBALgAwcAWAEZBALwAwUA6AEaBAIAAwQAeAEcBALwAwUACAEeBALgAwcAmAEfBALQAwkAKAEhBALAAwsAuAEiBALQAwkASAEkBALgAwcA2AElBALwAwUAaAEnBAIAAwQA+AEoBALwAwUAiAEqBALgAwcAGAEsBALQAwkAqAEtBALAAwsAOAEvBALQAwkAyAEwBALgAwcAWAEyBALwAwUA6AEzBAIAAwQAeAE1BALwAwUACAE3BALgAwcAmAE4BALQAwkAKAE6BALAAwsAuAE7BALQAwkASAE9BALgAwcA2AE+BALwAwUAaAFABAIAAwQA+AFBBALwAwUAiAFDBALgAwcAGAFFBALQAwkAqAFGBALAAwsAOAFIBALQAwkAyAFJBALgAwcAWAFLBALwAwUA6AFMBAIAAwQAeAFOBALwAwUACAFQBALgAwcAmAFRBwYABQAEAAMAAgABAAAA"
  },
  {
   "name": "candyLamp",
   "index": 5,
   "request": "$B0 = 5",
   "block": "$FA13",
   "bytes": "00 00 00 00 01 00 05 00 30 fa 00 07 00 0d 00 00 00 00 00 00 00 00 00 08 49 07 fa 28 29 45",
   "frames": 43,
   "introStartsDiffering": "4/236",
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+gUHBEkDCAIAAL8BOgMEQAC/AToAAAAAAgChAS4AAAAAAgC/AToAAAAAAgChAS4AAAAAAgChAS4AAAAAAgChAS4AAAAAAgChAS4AAAAAAgChAS4AAAAAAgC/AToHBgAFAAQAAwACAAEAAAA="
  }
 ]
}
